import React from "react";

import { validPhone } from "@origin-digital/validation";
import { pageRoutes } from "src/consts";
import { UpdatePhone } from "../UpdatePhone";

import { FieldUpdateHook } from "../../../crm/profileFieldMap";
import { ProfileFieldMapTypes } from "../../../crm/profileFieldMapContextHelpers";
import content from "./content.json";

export const UpdateHomePhoneScreen: React.FC<{
  homephone: string | null;
  useUpdate: FieldUpdateHook<string>;
  type: ProfileFieldMapTypes;
}> = ({ homephone, useUpdate, type }) => (
  <UpdatePhone
    value={homephone}
    content={content}
    useUpdatePhone={useUpdate}
    updateSuccessRoute={pageRoutes.updateLandline.success}
    type="homephone"
    validator={validPhone(content.phone.errors)}
    fieldMapType={type}
  />
);
